import { useIsMutating, useQuery } from '@tanstack/react-query';

import { DriverOptionOutput } from './types';
import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchDriverOptions = () => driverApi.get<void, DriverOptionOutput>('/v1/driver/options');

export const useFetchDriverOptions = () => {
  const isPatching = useIsMutating(mutationKeys.user.patchDriverOptions());

  return useQuery(queryKeys.user.fetchDriverOptions(), fetchDriverOptions, { enabled: !isPatching });
};
